/**
 * Parse levels and reduce them to their minimum representative value, e.g.
 * "1. klasse" -> "1."
 */
function shortenLevel(level) {
  return level.match(/(\d*?\.)/)?.[1] ?? level;
}

export { shortenLevel };
//# sourceMappingURL=shorten-level.js.map
